import { Component, OnInit, inject } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CONFIRM_TRANSLATE_CONTEXT } from '@shared/heplers/const-data';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-pr-confirm',
    templateUrl: './pr-confirm-modal.html',
    styleUrl: './pr-confirm-modal.scss',
    imports: [TranslateModule]
})
export class PrConfirm implements OnInit {
  modalRef = inject(BsModalRef);


  isConfirm: boolean = false;
  onConfirm: Function;
  ngOnInit() {
  }


  confirm(): void {
    this.isConfirm = true;
    this.onConfirm();
    this.modalRef.hide();
  }
 
  decline(): void {
    this.isConfirm = false;
    this.modalRef.hide();
  }
}
